import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginResponseModel } from '../models/login-response.model';
import { environment } from '../../environments/environment';
import { MfaVerifyRequest } from '../models/mfa-verify-request.model';

export const BYPASS_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

@Injectable({ providedIn: 'root' })
export class LoginService {
  private baseUrl = environment.APP_BASE_URL + '/doctor-login';

  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(
      `${this.baseUrl}/login`,
      {
        email: email,
        password: password,
      },
      { context: new HttpContext().set(BYPASS_INTERCEPTOR, true) },
    );
  }

  resendOtp(sessionId: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.baseUrl}/resend-otp`,
      {
        sessionId,
      },
      { context: new HttpContext().set(BYPASS_INTERCEPTOR, true) },
    );
  }

  verifyMfa(request: MfaVerifyRequest): Observable<LoginResponseModel> {
    return this.http.post<LoginResponseModel>(`${this.baseUrl}/verify-mfa`, request, {
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true),
    });
  }
}
